(function () {
    'use strict';

    angular
        .module('core.helpers')
        .service('LoadingHelper', LoadingHelper)

    /** @ngInject */
    function LoadingHelper($timeout) {
        const LoadingHelper = {
            startLoading: startLoading,
            stopLoading: stopLoading
        };

        return LoadingHelper;

        function startLoading(element, smaller = false) {
            $timeout(() => {
                let widget = $(element).closest('[data-widget]');
                let smallerClass = '';

                if ($(element).attr('[data-widget]'))
                    widget = $(element);

                if (smaller)
                    smallerClass = 'smaller';

                widget.append(`<div class="loading-body ${smallerClass}">
                                <img src="app/dist/images/progress-circle-complete.svg" alt="Carregando, aguarde...">
                            </div>`);
            })
        }

        function stopLoading(element) {
            $timeout(() => {
                let widget = $(element).closest('[data-widget]');

                if ($(element).attr('[data-widget]'))
                    widget = $(element);

                widget
                    .find('.loading-body')
                    .fadeOut(() => {
                        $(this).remove();
                    });
            })
        }
    }
}());